import { setComponentMapOverrides } from '@jutro/uiconfig';
import 'gw-capability-policychange-common-react';
import 'gw-capability-quoteandbind-bop-react';
import BOPPolicyDetailsPage from './pages/BOPPolicyDetails/BOPPolicyDetailsPage';
import BOPPolicyChangesPage from './pages/PolicyChanges/PolicyChangesPage';
import BOPAddressPage from './pages/Address/AddressPage';
import BOPItemDetailsPage from './pages/ItemDetails/ItemDetailsPage';
import PCBOPQuotePage from './pages/Quote/QuotePage';

setComponentMapOverrides(
    {
        BOPPolicyChangesPage: { component: 'BOPPolicyChangesPage' },
        BOPAddressPage: {component: 'BOPAddressPage'},
        BOPItemDetailsPage: {component: 'BOPItemDetailsPage'},
        BOPPolicyDetailsPage: { component: 'BOPPolicyDetailsPage' },
        PCBOPQuotePage: { component: 'PCBOPQuotePage' }
    },
    {
        BOPPolicyChangesPage,
        BOPAddressPage,
        BOPItemDetailsPage,
        BOPPolicyDetailsPage,
        PCBOPQuotePage
    }
);
